/**
 * Group conversations by date categories
 * @param {Array} conversations - Array of conversation objects with updatedAt field
 * @returns {Object} Grouped conversations { today, yesterday, lastWeek, older }
 */
export const groupConversationsByDate = (conversations) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const lastWeek = new Date(today);
  lastWeek.setDate(lastWeek.getDate() - 7);

  const groups = {
    today: [],
    yesterday: [],
    lastWeek: [],
    older: []
  };

  // Sort by updatedAt descending first
  const sorted = [...conversations].sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
  );

  sorted.forEach((conv) => {
    const date = new Date(conv.updatedAt);
    if (date >= today) {
      groups.today.push(conv);
    } else if (date >= yesterday) {
      groups.yesterday.push(conv);
    } else if (date >= lastWeek) {
      groups.lastWeek.push(conv);
    } else {
      groups.older.push(conv);
    }
  });

  return groups;
};

/**
 * Format date for display
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

/**
 * Get display label for date group
 * @param {string} groupKey - Group key (today, yesterday, lastWeek, older)
 * @returns {string} Display label
 */
export const getGroupLabel = (groupKey) => {
  const labels = {
    today: 'Today',
    yesterday: 'Yesterday',
    lastWeek: 'Last 7 days',
    older: 'Older'
  };
  return labels[groupKey] || groupKey;
};
